import React from 'react';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';
import { wssDetailsQueryStr } from '../../query/fragmentStrings';
import Loading from '../Common/Loading/Loading';
import PaymentSupportMessage from './PaymentSupportMessage';
import WssPaymentUpdateForm from './WssPaymentUpdateForm';
import WssOrderAmountSummary from './WssOrderAmountSummary';
import PaymentIssueExplanation from './PaymentIssueExplanation';
import PaymentStatusBanner from './PaymentStatusBanner';

const GET_WSS_DETAILS = gql`${wssDetailsQueryStr}`;

function WssPaymentAuthorizationSection({ orderNumber }) {
  const { data, loading, error } = useQuery(GET_WSS_DETAILS, {
    variables: { orderNumber },
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <PaymentStatusBanner message={{ value: 'Error loading payment details.' }} type="error" />;
  }

  const { wssPaymentDetails } = data?.orders?.orderDetailItems || {};

  if (!wssPaymentDetails || !wssPaymentDetails.paymentUpdateNeeded) {
    return null;
  }

  return (
    <div className="wss-payment-authorization">
      {wssPaymentDetails.initialErrorBannerMessage && (
        <PaymentStatusBanner message={wssPaymentDetails.initialErrorBannerMessage} type="error" />
      )}

      {wssPaymentDetails.showPaymentUpdateForm ? (
        <>
          <WssOrderAmountSummary
            orderTotalText={wssPaymentDetails.orderTotalText}
            amountDueText={wssPaymentDetails.amountDueText}
            orderTotalFormatted={wssPaymentDetails.grandTotalFormatted}
            amountDueFormatted={wssPaymentDetails.authAmountFormatted}
          />
          <div className="wss-payment-authorization-content">
            <div className="wss-payment-update-form-container">
              <WssPaymentUpdateForm
                orderNumber={orderNumber}
                wssPaymentDetails={wssPaymentDetails}
              />
            </div>
            <div className="wss-payment-issue-explanation-container">
              <PaymentIssueExplanation
                title={wssPaymentDetails.paymentErrorExplanationTitle}
                content={wssPaymentDetails.paymentErrorExplanationContent}
              />
            </div>
          </div>
        </>
      ) : (
        <PaymentSupportMessage message={wssPaymentDetails.paymentDeclinedMessage} />
      )}
    </div>
  );
}

WssPaymentAuthorizationSection.propTypes = {
  orderNumber: PropTypes.string.isRequired,
};

export default WssPaymentAuthorizationSection;
